import React, { useContext } from 'react';

import LazyLoad from 'react-lazyload';
import { withRouter } from 'react-router-dom'

import { useStore, getIsAuthenticated } from '../../Store'
import Hero from '../../components/hero';
import ExampleCommandLine from '../../components/ExampleCommandLine'
import Checks from './LandingPageGithub/Checks';
import Clients from '../../components/Clients'
import Testimonial from '../../components/Testimonial'
import Price from '../Price'
import Seo from '../../components/Seo'


export default withRouter(function(props) {
  const { state } = useStore()
  const isAuthenticated = getIsAuthenticated(state)
  // doing this only on first page load
  // will not redirect on page refresh or on internal navigation
  // will redirect on first page load
  if (window.history.state === null && !window.location.hash) {
    if (isAuthenticated) {
      props.history.push('/@me')
    }
  }

  return (
    <>
      <Seo />
      <Hero
        headline={'pip install django-doctor'}
        synopsis={"Django Doctor suggests code improvements to help you build world-class websites, release faster, and reduce dev costs. Example:"}
        linkUrl={"#price"}
        linkText={"Get Django Doctor"}
      />
      <Clients />
      <LazyLoad height={3070}>
        <ExampleCommandLine />
      </LazyLoad>
      <Testimonial />
      <Checks sassModel={false} />
      <Price saasModel={false} selfHostedModel={true} showCatalogue={true} />
    </>
  )
})

      